import React from 'react'

// components
import ResponsiveButton from 'components/atoms/ResponsiveButton'

const RemoveButton = props => {
  const { parent, setModal, align } = props

  if (parent.primaryAccountHolder) {
    return null
  }

  const handleClickRemove = () =>
    setModal({ id: `confirmDeleteParent${parent.id}`, open: true })

  return (
    <ResponsiveButton onClick={handleClickRemove} align={align}>
      Remove
    </ResponsiveButton>
  )
}

export default RemoveButton
